export class consultaReserva {
    public Id?: number;
    public Correo?: string = '';
    public Telefono?: string = '';
}